import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BidService } from '../../../services/bids.service';
import { LocalStorageService } from '../../../services/local-storage.service';
import { ScreenSizeService } from '../../../services/screen-size.service';

@Component({
  selector: 'app-pending-approval',
  templateUrl: './pending-approval.component.html',
  styleUrls: ['./pending-approval.component.css']
})
export class PendingApprovalComponent implements OnInit{
  isMobile: boolean = false;

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private bidService: BidService,
    private screenSizeService: ScreenSizeService
  ) {

  }

  async ngOnInit() {
    this.screenSizeService.isMobile$.subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }




  navigateTo(path: string) {
    this.localStorageService.clear()
    this.router.navigate([path]);
  }
}
